import { z } from "zod";
import { badgeSummarySchema } from "./badge.js";
import { cosmeticSummarySchema } from "./cosmetic.js";
import { userQuestSchema } from "./quest.js";

export const userProgressSchema = z.object({
	user_id: z.string(),
	total_xp: z.number().int().nonnegative(),
	level: z.number().int().min(1),
	current_streak: z.number().int().nonnegative(),
	longest_streak: z.number().int().nonnegative(),
	streak_last_active_at: z.number().int().positive().nullable(),
	level_progress: z.object({
		current_xp_in_level: z.number().int().nonnegative(),
		xp_to_next_level: z.number().int().nonnegative(),
		xp_for_current_level: z.number().int().nonnegative(),
		xp_for_next_level: z.number().int().nonnegative(),
	}),
	streak_extended: z.boolean(),
});

export type UserProgress = z.infer<typeof userProgressSchema>;

export const gamificationMeResponseSchema = z.object({
	progress: userProgressSchema,
	recent_badges: z.array(badgeSummarySchema),
	badges_unlocked_count: z.number().int().nonnegative(),
	badges_total_count: z.number().int().nonnegative(),
	active_quests: z.object({
		daily: z.array(userQuestSchema),
		weekly: z.array(userQuestSchema),
	}),
	cosmetics_unlocked_count: z.number().int().nonnegative(),
	cosmetics_total_count: z.number().int().nonnegative(),
	equipped_avatar_frame: cosmeticSummarySchema.nullable(),
	equipped_theme_accent: cosmeticSummarySchema.nullable(),
	equipped_sticker_pack: cosmeticSummarySchema.nullable(),
});

export type GamificationMeResponse = z.infer<typeof gamificationMeResponseSchema>;

export const publicProgressResponseSchema = z.object({
	user_id: z.string(),
	level: z.number().int().min(1),
	total_xp: z.number().int().nonnegative(),
	level_progress: z.object({
		current_xp_in_level: z.number().int().nonnegative(),
		xp_to_next_level: z.number().int().nonnegative(),
		xp_for_current_level: z.number().int().nonnegative(),
		xp_for_next_level: z.number().int().nonnegative(),
	}),
	current_streak: z.number().int().nonnegative(),
	longest_streak: z.number().int().nonnegative(),
	badges_unlocked_count: z.number().int().nonnegative(),
	badges_total_count: z.number().int().nonnegative(),
	top_badges: z.array(badgeSummarySchema).max(3),
	equipped_avatar_frame: cosmeticSummarySchema.nullable(),
	equipped_theme_accent: cosmeticSummarySchema.nullable(),
	equipped_sticker_pack: cosmeticSummarySchema.nullable(),
});

export type PublicProgressResponse = z.infer<typeof publicProgressResponseSchema>;
